import * as React from 'react';

import { cn } from '@/lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  /** Slot a Lucide icon on the left (16px recommended) */
  leftIcon?: React.ReactNode;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = 'text', leftIcon, ...props }, ref) => {
    const baseClasses = cn(
      'h-9 w-full rounded-sm border border-input bg-card text-base text-foreground',
      'placeholder:text-muted-foreground/70',
      'transition-[border-color,box-shadow] duration-150',
      'focus-visible:border-icaria-600 focus-visible:shadow-focus focus-visible:outline-none',
      'disabled:cursor-not-allowed disabled:opacity-50',
      type === 'number' || type === 'date' || type === 'time'
        ? 'font-mono tabular-nums'
        : '',
    );

    if (leftIcon) {
      return (
        <div className="relative">
          <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground [&>svg]:h-4 [&>svg]:w-4">
            {leftIcon}
          </span>
          <input
            ref={ref}
            type={type}
            className={cn(baseClasses, 'pl-9 pr-3', className)}
            {...props}
          />
        </div>
      );
    }

    return (
      <input
        ref={ref}
        type={type}
        className={cn(baseClasses, 'px-3', className)}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
